<section id="main-container">
  <div id="main" class="col-xs-12">
    <app-breadcrumb
      currentPage="Minhas Fichas"
      routerCurrentPage="/ficha"
      [currentPageDetail]="fichaTimeline?.cliente?.nome"
    >
      <a
        *ngIf="isResultadoParcialCurrent"
        class="remove-ficha"
        (click)="onClickExcluirFicha()"
        title="Excluir Ficha"
      >
        <span class="fa fa-trash"></span> Excluir
      </a>
    </app-breadcrumb>

    <app-central-loader
      [text]="
        loadingSaveAvalista
          ? 'Salvando avalista'
          : 'Carregando dados da proposta'
      "
      [show]="isBuscando || loadingSaveAvalista"
      [ngClass]="{ 'app-central-loader': isBuscando || loadingSaveAvalista }"
    ></app-central-loader>

    <div *ngIf="errorMessage" class="alert alert-danger alert-dismissable">
      <strong>Erro ao buscar ficha: </strong> {{ errorMessage }}
    </div>

    <!-- TIMELINE -->
    <div
      *ngIf="fichaTimeline.isFicha"
      id="client-track"
      class="row"
      [ngClass]="{ 'no-scroll': loadingSaveAvalista }"
    >
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-lg-offset-1 col-xl-8 col-xl-offset-2"
      >
        <!-- Banner -->
        <div class="banner">
          <div class="row date">
            <div class="col-xs-4 text-left">
              Ficha:<span>{{ fichaTimeline.proposta.id }}</span>
            </div>
            <div class="col-xs-4 text-center">
              Iniciada:<span>{{
                fichaTimeline.proposta.dataHoraEnvio | date : 'dd/MM/y'
              }}</span
              >|<span>{{
                fichaTimeline.proposta.dataHoraEnvio | date : 'H:mm'
              }}</span>
            </div>
            <div class="col-xs-4 text-right">
              <!-- Operador -->
              <div *ngIf="fichaTimeline.vendedor" class="user">
                <img
                  class="user-photo margin-0"
                  src="{{ fichaTimeline.vendedor.urlFoto }}"
                  border="0"
                  alt="Foto usuário."
                  appFallbackImage
                />
                <span class="name hidden-xs">
                  <span class="text-left">
                    <small>{{
                      fichaTimeline.vendedor.nmLoja | titlecase
                    }}</small>
                    {{ fichaTimeline.vendedor.nome | titlecase }}
                  </span>
                </span>
              </div>
              <!-- Lojista -->
              <div *ngIf="fichaTimeline.promotor" class="user">
                <img
                  class="user-photo margin-0"
                  src="{{ fichaTimeline.promotor.urlFoto }}"
                  border="0"
                  alt="Foto usuário."
                  appFallbackImage
                />
                <span class="name hidden-xs">
                  <span class="text-left">
                    {{ fichaTimeline.promotor.nome | titlecase }}
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div class="row client">
            <div class="col-xs-12">
              <span class="title">{{
                fichaTimeline?.cliente?.categoria === 'J'
                  ? 'Razão Social'
                  : 'Cliente'
              }}</span>
              <div class="content-name">
                <app-ficha-timeline-add-avalista
                  class=""
                  [proposta]="fichaTimeline"
                  (isSavingAvalista)="saveAvalista($event)"
                ></app-ficha-timeline-add-avalista>
                <h2>{{ fichaTimeline.cliente.nome }}</h2>
                <app-ficha-timeline-sos-inverso
                  [proposta]="fichaTimeline?.proposta"
                  (sosEnviado)="buscarFicha()"
                  *ngIf="isShowEnviarSOS()"
                ></app-ficha-timeline-sos-inverso>
              </div>
              <span class="user-id">
                {{ fichaTimeline?.cliente?.categoria === 'J' ? 'CNPJ' : 'CPF' }}
                :
                {{
                  fichaTimeline?.cliente?.categoria === 'J'
                    ? (fichaTimeline.cliente.cpf | cnpj)
                    : (fichaTimeline.cliente.cpf | cpf)
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Banner (Final) -->

        <!-- Timeline -->
        <div class="events">
          <ul class="timeline">
            <li
              *ngFor="let tl of fichaTimeline.timeline; odd as isPar"
              [ngClass]="{
                'timeline-inverted': isPar,
                parcial: isResultadoParcial(tl),
                'direct-analysis': isAguardandoAnaliseDireta(tl),
                analysis: isEmAnaliseDireta(tl),
                approved: isAprovada(tl),
                'pre-contract-emission': isEmissaoPreContrato(tl),
                'required-docs': isDocumentacaoNecessaria(tl),
                'digital-signature': isAssinaturaDigital(tl),
                'send-docs': isDocumentacaoEnviada(tl),
                'analysis-docs': isDocumentacaoEmAnalise(tl),
                scheduled: isPagamentoAgendado(tl),
                'paid-out': isPagamentoRealizado(tl),
                contract: isContratoDisponivel(tl),
                reproved: isReprovada(tl),
                analysisB: isReprovadaFormalizacao(tl)
              }"
            >
              <app-ficha-timeline-resultado-parcial
                *ngIf="isResultadoParcial(tl)"
                [timeline]="tl"
                [proposta]="fichaTimeline?.proposta"
                [timelineActive]="isActive(tl)"
                [idFicha]="fichaTimeline.proposta.id"
                [isFichaResultadoParcial]="isResultadoParcialCurrent"
              ></app-ficha-timeline-resultado-parcial>
              <app-ficha-timeline-aguardando-analise-direta
                *ngIf="isAguardandoAnaliseDireta(tl)"
                [timeline]="tl"
                [timelineActive]="isActive(tl)"
              ></app-ficha-timeline-aguardando-analise-direta>

              <app-ficha-timeline-em-analise-direta
                *ngIf="isEmAnaliseDireta(tl)"
                [produtoProposta]="
                  fichaTimeline._fichaTimeline.timelineProposta.produtoProposta
                "
                [timeline]="tl"
                [timelineActive]="isActive(tl)"
                [idFicha]="fichaTimeline.proposta.id"
                [cliente]="fichaTimeline.cliente"
              >
              </app-ficha-timeline-em-analise-direta>

              <app-ficha-timeline-aprovada
                *ngIf="isAprovada(tl)"
                [timeline]="tl"
                [proposta]="fichaTimeline?.proposta"
                [timelineActive]="isActive(tl)"
                [idFicha]="fichaTimeline.proposta.id"
              >
              </app-ficha-timeline-aprovada>

              <app-ficha-timeline-assinatura-digital
                *ngIf="isAssinaturaDigital(tl)"
                [timeline]="tl"
                [proposta]="fichaTimeline?.proposta"
                [timelineActive]="isActive(tl)"
              ></app-ficha-timeline-assinatura-digital>
              <app-ficha-timeline-emissao-pre-contrato
                *ngIf="isEmissaoPreContrato(tl)"
                [timeline]="tl"
                [proposta]="fichaTimeline?.proposta"
                [timelineActive]="isActive(tl)"
              ></app-ficha-timeline-emissao-pre-contrato>
              <app-ficha-timeline-documentacao-necessaria
                *ngIf="isDocumentacaoNecessaria(tl)"
                [fullTimeline]="fichaTimeline.timeline"
                [timeline]="tl"
                [timelineActive]="isActive(tl)"
                [idFicha]="fichaTimeline.proposta.id"
                [cliente]="fichaTimeline.cliente"
              >
              </app-ficha-timeline-documentacao-necessaria>
              <app-ficha-timeline-documentacao-enviada
                *ngIf="isDocumentacaoEnviada(tl)"
                [timeline]="tl"
                [timelineActive]="isActive(tl)"
              ></app-ficha-timeline-documentacao-enviada>

              <app-ficha-timeline-documentacao-em-analise
                *ngIf="isDocumentacaoEmAnalise(tl)"
                [timeline]="tl"
                [timelineActive]="isActive(tl)"
                [cliente]="fichaTimeline.cliente"
                [idFicha]="fichaTimeline.proposta.id"
              ></app-ficha-timeline-documentacao-em-analise>
              <app-ficha-timeline-pagamento-agendado
                *ngIf="isPagamentoAgendado(tl)"
                [timeline]="tl"
                [timelineActive]="isActive(tl)"
              ></app-ficha-timeline-pagamento-agendado>
              <app-ficha-timeline-pagamento-realizado
                *ngIf="isPagamentoRealizado(tl)"
                [timeline]="tl"
                [timelineActive]="isActive(tl)"
              ></app-ficha-timeline-pagamento-realizado>
              <app-ficha-timeline-contrato-disponivel
                *ngIf="isContratoDisponivel(tl)"
                [timeline]="tl"
                [timelineActive]="isActive(tl)"
              ></app-ficha-timeline-contrato-disponivel>
              <app-ficha-timeline-reprovada
                *ngIf="isReprovada(tl) || isReprovadaFormalizacao(tl)"
                [timeline]="tl"
                [timelineActive]="isActive(tl)"
              ></app-ficha-timeline-reprovada>
            </li>
            <li class="clearfix no-float"></li>
          </ul>
        </div>
        <!-- Timeline (Final) -->
      </div>
    </div>
  </div>
</section>

<app-modal-loader #modalLoader></app-modal-loader>

<app-modal-message #modalMessage title="Atenção"></app-modal-message>
